"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextViewer = void 0;
var rich_text_viewer_1 = require("@csod/rich-text-viewer");
exports.RichTextViewer = rich_text_viewer_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["RichTextViewer"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/RichTextViewer/RichTextViewer.js
// module id = 231
// module chunks = 0